import { Helmet, HelmetProvider } from 'react-helmet-async';
import {
    Typography,
    Stack,
    Grid,
    Card,
    Box,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    useTheme,
    ToggleButton,
    ToggleButtonGroup,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    TextField,
    InputAdornment,
    Button,
    Chip,
    Modal,
    Tooltip,
    TableSortLabel,
    CircularProgress
} from '@mui/material';
import { useState, useEffect } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from 'moment';
import { toast } from 'react-toastify';
import api from 'src/services/BaseService'; // Projenizdeki API servisi yolu
import Services from 'src/services/Services';
import axios from 'axios';
import { StatusList } from 'src/types/statusTypes';


const SearchIcon = ({ size = 20, color = 'currentColor' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="11" cy="11" r="8"></circle>
        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
);

const SendIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.22002 6.78002L14.7534 1.24669" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15 4.53331V1H11.4667" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 1H4.5C2 1 1 2 1 4.5V11.5C1 14 2 15 4.5 15H11.5C14 15 15 14 15 11.5V9" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const CloseIcon = ({ size = 24, color = 'currentColor' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6 6L18 18" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const FilterIcon = ({ size = 20, color = 'currentColor' }) => (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 10H15M2.5 5H17.5M7.5 15H12.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const CalendarIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.8333 3.33331H4.16667C3.24619 3.33331 2.5 4.0795 2.5 4.99998V16.6666C2.5 17.5871 3.24619 18.3333 4.16667 18.3333H15.8333C16.7538 18.3333 17.5 17.5871 17.5 16.6666V4.99998C17.5 4.0795 16.7538 3.33331 15.8333 3.33331Z" stroke="#98A2B3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M13.3333 1.66669V5.00002" stroke="#98A2B3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.66669 1.66669V5.00002" stroke="#98A2B3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2.5 8.33331H17.5" stroke="#98A2B3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const mallColors = [
    '#38BDF8', '#6366F1', '#1D4ED8', '#0F172A', '#38BDF8', '#F79009', '#A259F7',
];

const MallWorkloadChart = ({ data: propData, filter, onFilterChange }) => {
    const theme = useTheme();
    const data = propData && propData.length > 0 ? propData.map((item, idx) => ({
        name: item.mallTitle,
        value: Number(item.total),
        color: mallColors[idx % mallColors.length],
    })) : [
        { name: 'AVM 1', value: 1400, color: mallColors[0] },
        { name: 'AVM 2', value: 1750, color: mallColors[1] },
        { name: 'AVM 3', value: 2100, color: mallColors[2] },
        { name: 'AVM 4', value: 2550, color: mallColors[3] },
        { name: 'AVM 5', value: 1280, color: mallColors[4] },
    ];
    const maxValue = Math.max(...data.map(d => d.value), 2500);
    return (
        <Card sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography variant="h6" sx={{ fontSize: '1rem' }}>AVM'lere Göre İş Dağılımı (En Yoğun 5 AVM)</Typography>
                <FormControl size="small" sx={{ minWidth: 120 }}>
                    <Select value={filter} onChange={(e) => onFilterChange(e.target.value)}>
                        <MenuItem value="1d">Günlük</MenuItem>
                        <MenuItem value="7d">7 Günlük</MenuItem>
                        <MenuItem value="15d">15 Günlük</MenuItem>
                        <MenuItem value="30d">30 Günlük</MenuItem>
                        <MenuItem value="3m">3 Aylık</MenuItem>
                    </Select>
                </FormControl>
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>Toplam İş Sayısı</Typography>
            <Box sx={{ flexGrow: 1, overflowX: 'auto', pb: 1 }}>
                <Box sx={{ minWidth: '500px', height: '100%', minHeight: '250px', display: 'flex', pl: 4, position: 'relative' }}>
                    <Stack sx={{ height: 'calc(100% - 24px)', justifyContent: 'space-between', position: 'absolute', left: 0, top: 0 }}>
                        {[...Array(6)].map((_, i) => (
                            <Typography key={i} variant="caption" color="text.secondary">{Math.round(maxValue - (i * (maxValue / 5)))}</Typography>
                        ))}
                    </Stack>
                    <Stack direction="row" spacing={2} sx={{ width: '100%', alignItems: 'flex-end' }}>
                        {data.map((item, index) => (
                            <Stack key={index} sx={{ flex: 1, height: '100%', alignItems: 'center', justifyContent: 'flex-end' }}>
                                <Tooltip title={`${item.name}: ${item.value}`} arrow>
                                    <Box
                                        sx={{
                                            width: '50%',
                                            height: `${(item.value / maxValue) * 100}%`,
                                            backgroundColor: item.color,
                                            borderRadius: '4px 4px 0 0',
                                            transition: 'height 0.3s ease-in-out'
                                        }}
                                    />
                                </Tooltip>
                                <Typography variant="caption" sx={{ mt: 0.5, whiteSpace: 'pre' }}>{item.name}</Typography>
                            </Stack>
                        ))}
                    </Stack>
                </Box>
            </Box>
        </Card>
    );
};

const MallTimeDensityChart = ({ data: propData, filter, onFilterChange }) => {
    const theme = useTheme();
    const startHour = 9;
    const now = new Date();
    const endHour = now.getHours();
    const timeRange = `${startHour < 10 ? '0' : ''}${startHour}:00 - ${endHour < 10 ? '0' : ''}${endHour}:00`;
    // Saat legend array'i
    const timeSlots = Array.from({ length: endHour - startHour + 1 }, (_, i) => {
        const hour = startHour + i;
        return `${hour < 10 ? '0' : ''}${hour}:00`;
    });
    const data = propData && propData.length > 0 ? propData.map((item, idx) => ({
        name: item.mallTitle,
        value: Number(item.total),
        color: mallColors[idx % mallColors.length],
    })) : [
        { name: 'AVM 1', value: 443, color: mallColors[0] },
        { name: 'AVM 2', value: 405, color: mallColors[1] },
        { name: 'AVM 3', value: 400, color: mallColors[2] },
        { name: 'AVM 4', value: 316, color: mallColors[3] },
        { name: 'AVM 5', value: 287, color: mallColors[4] },
    ];
    const maxValue = Math.max(...data.map(d => d.value), 500);
    return (
        <Card sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography variant="h6" sx={{ fontSize: '1rem' }}>AVM Zaman Bazlı Yoğunluk Dağılımı</Typography>
                <FormControl size="small" sx={{ minWidth: 120 }}>
                    <Select value={filter} onChange={(e) => onFilterChange(e.target.value)}>
                        <MenuItem value="1d">Günlük</MenuItem>
                        <MenuItem value="7d">7 Günlük</MenuItem>
                        <MenuItem value="15d">15 Günlük</MenuItem>
                        <MenuItem value="30d">30 Günlük</MenuItem>
                        <MenuItem value="3m">3 Aylık</MenuItem>
                    </Select>
                </FormControl>
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>Saat Aralığı: <b>{timeRange}</b></Typography>
            <Box sx={{ flexGrow: 1, overflowX: 'auto', pb: 2 }}>
                <Stack spacing={2.5} sx={{ minWidth: '400px' }}>
                    {data.map((item, index) => (
                        <Stack key={index} direction="row" alignItems="center" spacing={2}>
                            <Typography variant="caption" sx={{ width: '120px', minWidth: '120px', textAlign: 'right' }}>{item.name}</Typography>
                            <Tooltip title={`${item.value} işlem`} arrow>
                                <Box sx={{ flex: 1, height: '30px', backgroundColor: theme.palette.grey[200], borderRadius: '4px', position: 'relative', minWidth: 40 }}>
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            left: 0,
                                            top: 0,
                                            height: '100%',
                                            width: `${(item.value / maxValue) * 100}%`,
                                            backgroundColor: item.color,
                                            borderRadius: '4px',
                                            transition: 'width 0.3s',
                                            display: 'flex',
                                            alignItems: 'center',
                                            pl: 1,
                                            color: '#fff',
                                            fontWeight: 600
                                        }}
                                    >
                                        {item.value}
                                    </Box>
                                </Box>
                            </Tooltip>
                        </Stack>
                    ))}
                    {/* Saat legend'ı */}
                    <Box sx={{ position: 'relative', height: '20px', mt: 1, pl: '120px', mr: '16px' }}>
                        <Stack direction="row" justifyContent="space-between" sx={{ width: '100%' }}>
                            {timeSlots.map((time) => (
                                <Typography key={time} variant="caption" color="text.secondary">
                                    {time}
                                </Typography>
                            ))}
                        </Stack>
                    </Box>
                </Stack>
            </Box>
        </Card>
    );
};

const MallWorkloadTable = ({ data: propData }) => {
    const theme = useTheme();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(6);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedMall, setSelectedMall] = useState(null);
    const [notificationType, setNotificationType] = useState('hizli');
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('name');
    const [search, setSearch] = useState('');

    // Eğer propData varsa onu, yoksa mockData'yı kullan
    const mockData = [
        { id: 1, name: 'Mark Antalya', waiting: 12, delayed: 12, completed: 12, cancelled: 'Küçük Araç', avgTime: 1, density: 'Normal' },
        { id: 2, name: 'Antalya Migros', waiting: 8, delayed: 8, completed: 8, cancelled: 'Palet', avgTime: 2, density: 'Kritik' },
        { id: 3, name: 'The Land of The Legends', waiting: 18, delayed: 18, completed: 18, cancelled: 'Büyük Araç', avgTime: 1, density: 'Normal' },
        { id: 4, name: 'Mall Of Antalya/Deepo', waiting: 21, delayed: 21, completed: 21, cancelled: 'Küçük Araç', avgTime: 3, density: 'Yoğun' },
        { id: 5, name: 'Isparta Meydan AVM', waiting: 18, delayed: 18, completed: 18, cancelled: 'Büyük Araç', avgTime: 2, density: 'Aktif' },
        { id: 6, name: 'Terra City', waiting: 19, delayed: 19, completed: 19, cancelled: 'Büyük Araç', avgTime: 2, density: 'Aktif' },
    ];
    const data = propData && propData.length > 0 ? propData.map((item, idx) => ({
        id: idx + 1,
        name: item.mallTitle,
        waiting: Number(item.waitingPosts),
        delayed: Number(item.lateWaitingPosts),
        completed: Number(item.completedPosts),
        cancelled: Number(item.cancelledPosts),
        avgTime: '-', // API'de yok, placeholder
        density: '-', // API'de yok, placeholder
    })) : mockData;

    // Filtrelenmiş veri
    const filteredData = data.filter(row => (row.name || '').toLowerCase().includes(search.toLowerCase()));

    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const getComparator = (order, orderBy) => {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    };

    const descendingComparator = (a, b, orderBy) => {
        if (b[orderBy] < a[orderBy]) return -1;
        if (b[orderBy] > a[orderBy]) return 1;
        return 0;
    };

    const stableSort = (array, comparator) => {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    };

    const handleOpenModal = (row) => {
        setSelectedMall(row);
        setModalOpen(true);
    };
    const handleCloseModal = () => setModalOpen(false);

    const handleChangePage = (event, newPage) => setPage(newPage);
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const getDensityChip = (density) => {
        let styles = { color: '#737373', backgroundColor: '#FAFAFA', border: '1px solid #E5E5E5' };
        if (density === 'Normal') styles = { color: '#027A48', backgroundColor: '#ECFDF3', border: '1px solid #ABEFC6' };
        else if (density === 'Kritik') styles = { color: '#B42318', backgroundColor: '#FEF3F2', border: '1px solid #FECDCA' };
        else if (density === 'Yoğun') styles = { color: '#B54708', backgroundColor: '#FFFAEB', border: '1px solid #FEDF89' };
        else if (density === 'Aktif') styles = { color: '#17B26A', backgroundColor: '#F0FDF4', border: '1px solid #BBF7D0' };
        return <Chip label={density} size="small" sx={{ ...styles, borderRadius: '16px' }} />;
    };

    const getNotificationMessage = () => {
        if (!selectedMall) return '';
        if (notificationType === 'hizli') return `Sayın [Takım Lideri Adı], ${selectedMall.name} operasyonunuz kritik durumdadır, acilen müdahale etmeniz gerekmektedir.`;
        return `Sayın [Takım Lideri Adı], ${selectedMall.name} operasyonunuzda yoğunluk mevcuttur, en kısa sürede müdahale etmeniz gerekmektedir.`;
    };

    const modalStyle = { position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'background.paper', borderRadius: '8px', boxShadow: 24, p: 3 };

    const headCells = [
        { id: 'name', label: 'AVM ADI' },
        { id: 'waiting', label: 'BEKLEYEN İŞ EMRİ' },
        { id: 'delayed', label: 'GECİKEN İŞ EMRİ' },
        { id: 'completed', label: 'TAMAMLANAN İŞ EMRİ' },
        { id: 'cancelled', label: 'İPTAL EDİLEN İŞ' },
        { id: 'avgTime', label: 'ORT. TAMAMLAMA SÜRESİ' },
        { id: 'density', label: 'YOĞUNLUK' },
    ];

    return (
        <Card>
            <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
                <Typography variant="h6">AVM İş Yoğunluğu Takip Listesi</Typography>
                <TextField
                    placeholder="AVM ara..."
                    variant="outlined"
                    size="small"
                    value={search}
                    onChange={e => { setSearch(e.target.value); setPage(0); }}
                    InputProps={{ startAdornment: (<InputAdornment position="start"><SearchIcon /></InputAdornment>), }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' }, minWidth: { sm: 300 } }}
                />
            </Box>
            <TableContainer>
                <Table sx={{ minWidth: 1200 }}>
                    <TableHead sx={{ backgroundColor: theme.palette.grey[100] }}>
                        <TableRow>
                            {headCells.map((headCell) => (
                                <TableCell key={headCell.id} sortDirection={orderBy === headCell.id ? order : false} sx={{ whiteSpace: 'nowrap' }}>
                                    {headCell.disableSorting ? (
                                        headCell.label
                                    ) : (
                                        <TableSortLabel active={orderBy === headCell.id} direction={orderBy === headCell.id ? order : 'asc'} onClick={() => handleRequestSort(headCell.id)}>
                                            {headCell.label}
                                        </TableSortLabel>
                                    )}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredData.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={headCells.length} align="center">Veri bulunamadı</TableCell>
                            </TableRow>
                        ) : (
                            stableSort(filteredData, getComparator(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row) => (
                                    <TableRow key={row.id} hover>
                                        <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.name}</TableCell>
                                        <TableCell>{row.waiting}</TableCell>
                                        <TableCell>{row.delayed}</TableCell>
                                        <TableCell>{row.completed}</TableCell>
                                        <TableCell>{row.cancelled}</TableCell>
                                        <TableCell>{row.avgTime}</TableCell>
                                        <TableCell>{getDensityChip(row.density)}</TableCell>
                                    </TableRow>
                                ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination rowsPerPageOptions={[6, 10, 25]} component="div" count={filteredData.length} rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage} />
            <Modal open={modalOpen} onClose={handleCloseModal}>
                <Box sx={modalStyle}>
                    <Stack spacing={3}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography variant="h6">Bildirim Gönder</Typography>
                            <Button onClick={handleCloseModal} sx={{ minWidth: 'auto', p: 0.5 }}><CloseIcon color={theme.palette.grey[500]} /></Button>
                        </Box>
                        <FormControl fullWidth size="small">
                            <Select value={notificationType} onChange={(e) => setNotificationType(e.target.value)}>
                                <MenuItem value="hizli">Hızlı müdahale bildirimi</MenuItem>
                                <MenuItem value="uyari">Uyarı bildirimi</MenuItem>
                            </Select>
                        </FormControl>
                        <TextField multiline rows={4} value={getNotificationMessage()} fullWidth InputProps={{ readOnly: true }} />
                        <Stack direction="row" spacing={1} justifyContent="flex-end">
                            <Button variant="outlined" onClick={handleCloseModal}>İptal</Button>
                            <Button variant="contained" onClick={handleCloseModal}>Gönder</Button>
                        </Stack>
                    </Stack>
                </Box>
            </Modal>
        </Card>
    );
};

// --- DeliveryNoteTrackingTable güncelle ---
const DeliveryNoteTrackingTable = ({ data: propData }) => {
    const theme = useTheme();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(6);
    const [search, setSearch] = useState('');

    const data = propData && propData.length > 0 ? propData : [];
    const filteredData = data.filter(row => (row.mallName || '').toLowerCase().includes(search.toLowerCase()));
    const headCells = [
        { id: 'mallName', label: 'AVM ADI' },
        { id: 'totalNotes', label: 'TOPLAM İRSALİYE' },
        { id: 'totalPackages', label: 'TOPLAM PAKET SAYISI' },
        { id: 'storeJob', label: 'MAĞAZA AÇILAN İŞ' },
        { id: 'cancelled', label: 'İPTAL EDİLEN' },
    ];

    const handleChangePage = (event, newPage) => setPage(newPage);
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <Card>
            <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
                <Typography variant="h6">İrsaliye Takip Listesi</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <TextField
                        placeholder="AVM ara..."
                        variant="outlined"
                        size="small"
                        value={search}
                        onChange={e => { setSearch(e.target.value); setPage(0); }}
                        InputProps={{ startAdornment: (<InputAdornment position="start"><SearchIcon /></InputAdornment>), }}
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' }, minWidth: { sm: 300 } }}
                    />
                    <Button variant="outlined" startIcon={<FilterIcon color={theme.palette.text.primary} />} sx={{ color: theme.palette.text.primary, borderColor: theme.palette.grey[400] }}>Filtreler</Button>
                </Box>
            </Box>
            <TableContainer>
                <Table sx={{ minWidth: 900 }}>
                    <TableHead sx={{ backgroundColor: theme.palette.grey[100] }}>
                        <TableRow>
                            {headCells.map((headCell) => (
                                <TableCell key={headCell.id} sx={{ whiteSpace: 'nowrap' }}>{headCell.label}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
                            <TableRow key={row.id} hover>
                                <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.mallName}</TableCell>
                                <TableCell>{row.totalNotes}</TableCell>
                                <TableCell>{row.totalPackages}</TableCell>
                                <TableCell>{row.storeJob}</TableCell>
                                <TableCell>{row.cancelled}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                component="div"
                count={filteredData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage="Sayfa başına satır:"
                labelDisplayedRows={({ from, to, count }) => `Toplam ${count} kayıttan ${from}-${to} arası gösteriliyor`}
            />
        </Card>
    );
};

// --- TopPortersTable güncelle ---
const TopPortersTable = ({ data: propData }) => {
    const theme = useTheme();
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(6);
    const data = propData && propData.length > 0 ? propData : [];
    const filteredData = data.filter(row => (row.porterName || '').toLowerCase().includes(search.toLowerCase()));
    const headCells = [
        { id: 'rank', label: 'SIRA NO' },
        { id: 'porterName', label: 'PORTER ADI' },
        { id: 'signedNotes', label: 'İMZALANAN İRSALİYE SAYISI' },
    ];
    const handleChangePage = (event, newPage) => setPage(newPage);
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    return (
        <Card>
            <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
                <Typography variant="h6">En Fazla İrsaliye İmzalatan Porter Listesi</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <TextField
                        placeholder="Porter adı ara..."
                        variant="outlined"
                        size="small"
                        value={search}
                        onChange={e => { setSearch(e.target.value); setPage(0); }}
                        InputProps={{ startAdornment: (<InputAdornment position="start"><SearchIcon /></InputAdornment>), }}
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' }, minWidth: { sm: 300 } }}
                    />
                    <Button variant="outlined" startIcon={<FilterIcon color={theme.palette.text.primary} />} sx={{ color: theme.palette.text.primary, borderColor: theme.palette.grey[400] }}>Filtreler</Button>
                </Box>
            </Box>
            <TableContainer>
                <Table sx={{ minWidth: 800 }}>
                    <TableHead sx={{ backgroundColor: theme.palette.grey[100] }}>
                        <TableRow>
                            {headCells.map((headCell) => (
                                <TableCell key={headCell.id} sx={{ whiteSpace: 'nowrap' }}>{headCell.label}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
                            <TableRow key={row.id} hover>
                                <TableCell>{row.id}</TableCell>
                                <TableCell>{row.porterName}</TableCell>
                                <TableCell>{row.signedNotes}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                component="div"
                count={filteredData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage="Sayfa başına satır:"
                labelDisplayedRows={({ from, to, count }) => `Toplam ${count} kayıttan ${from}-${to} arası gösteriliyor`}
            />
        </Card>
    );
};

const CompletionTimeChart = ({ title, data }) => {
    const theme = useTheme();
    const maxValue = 7;
    const timeSlots = Array.from({ length: maxValue }, (_, i) => `${i + 1} saat`);

    return (
        <Card sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Typography variant="h6" sx={{ mb: 1, fontSize: '1rem' }}>{title}</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>AVM Ortalama İş Bitirme Süreleri</Typography>

            <Stack spacing={2} sx={{ flexGrow: 1 }}>
                {data.map((item, index) => {
                    const minutes = (Number(item.value) * 60).toFixed(0);
                    return (
                        <Stack key={index} direction="row" alignItems="center" spacing={2}>
                            <Typography variant="caption" sx={{ width: '60px', minWidth: '60px', textAlign: 'right' }}>{item.name}</Typography>
                            <Box sx={{ flex: 1, height: '30px', backgroundColor: theme.palette.grey[200], borderRadius: '4px', position: 'relative' }}>
                                <Tooltip title={`${Number(item.value).toFixed(2)} saat (${minutes} dakika)`} arrow>
                                    <Box
                                        sx={{
                                            width: `${(item.value / maxValue) * 100}%`,
                                            height: '100%',
                                            backgroundColor: item.color,
                                            borderRadius: '4px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            pl: 1,
                                            color: '#fff',
                                            fontWeight: 600,
                                            position: 'relative',
                                            transition: 'width 0.3s',
                                        }}
                                    >
                                        <span style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', fontSize: 13, color: '#fff', fontWeight: 700 }}>
                                            {minutes} dk
                                        </span>
                                    </Box>
                                </Tooltip>
                            </Box>
                        </Stack>
                    );
                })}
            </Stack>

            <Stack direction="row" justifyContent="space-around" sx={{ mt: 2, pl: '76px' }}>
                {timeSlots.map(time => (
                    <Typography key={time} variant="caption" color="text.secondary">{time}</Typography>
                ))}
            </Stack>
        </Card>
    );
};

const StackedBarChart = ({ title, subtitle, data, series, colors, maxValue }) => {
    const theme = useTheme();

    return (
        <Card sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Typography variant="h6" sx={{ mb: 1, fontSize: '1rem' }}>{title}</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>{subtitle}</Typography>
            <Box sx={{ flexGrow: 1, overflowX: 'auto', pb: 1 }}>
                <Box sx={{ minWidth: `${Math.max(data.length * 120, 500)}px`, height: '100%', minHeight: '250px', display: 'flex', pl: 4, position: 'relative' }}>
                    <Stack sx={{ height: 'calc(100% - 24px)', justifyContent: 'space-between', position: 'absolute', left: 0, top: 0 }}>
                        {[...Array(6)].map((_, i) => (
                            <Typography key={i} variant="caption" color="text.secondary">{Math.round(maxValue - (i * (maxValue / 5)))}</Typography>
                        ))}
                    </Stack>
                    <Stack direction="row" spacing={2} sx={{ width: '100%', alignItems: 'flex-end' }}>
                        {data.map((item) => (
                            <Tooltip
                                key={item.name}
                                title={
                                    <Box>
                                        {series.map((s) => (
                                            <Typography key={s.key} variant="body2" sx={{ fontSize: '0.75rem' }}>
                                                {s.label}:
                                                <Typography component="span" fontWeight="bold" sx={{ fontSize: '0.75rem' }}> {item[s.key]}</Typography>
                                            </Typography>
                                        ))}
                                    </Box>
                                }
                                placement="top"
                                arrow
                            >
                                <Stack sx={{ flex: 1, height: '100%', alignItems: 'center', justifyContent: 'flex-end', position: 'relative' }}>
                                    <Stack sx={{ width: '50%', height: '100%', justifyContent: 'flex-end', borderRadius: '4px 4px 0 0', overflow: 'hidden' }}>
                                        {series.map((s, index) => (
                                            <Box
                                                key={s.key}
                                                sx={{
                                                    width: '100%',
                                                    height: `${(item[s.key] / maxValue) * 100}%`,
                                                    backgroundColor: colors[index],
                                                    transition: 'opacity 0.2s',
                                                    '&:hover': { opacity: 0.8 }
                                                }}
                                            />
                                        ))}
                                    </Stack>
                                    <Typography variant="caption" sx={{ mt: 0.5, minWidth: 100, textAlign: 'center', wordBreak: 'break-word' }}>{item.name}</Typography>
                                </Stack>
                            </Tooltip>
                        ))}
                    </Stack>
                </Box>
            </Box>
            <Stack direction="row" justifyContent="center" spacing={2} sx={{ mt: 2, borderTop: `1px solid ${theme.palette.divider}`, pt: 1.5 }}>
                {series.map((s, index) => (
                    <Typography key={s.key} variant="body2" sx={{ display: 'flex', alignItems: 'center', color: '#6B7280', fontSize: 12 }}>
                        <Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: colors[index], mr: 1 }} />
                        {s.label}
                    </Typography>
                ))}
            </Stack>
        </Card>
    );
};

const ReportGenerator = () => {

    // Getting Mall IDs
    const getPointIDs = () => {
        try {
            const userStr = localStorage.getItem('user');
            if (userStr) {
                const user = JSON.parse(userStr);
                if (user.authLocations && user.authLocations.mall && Array.isArray(user.authLocations.mall)) {
                    setSelectedMallIds(user.authLocations.mall.map(mall => mall.id));
                    return user.authLocations.mall.map(mall => mall.id);
                }
            }
        } catch (e) {
            console.error("Kullanıcı verisi alınamadı:", e);
        }
    };

    const theme = useTheme();

    // --- STATE'LER ---
    const [startDate, setStartDate] = useState(dayjs().startOf('month')); // Ayın ilk gününü ata
    const [endDate, setEndDate] = useState(dayjs()); // Bugünü ata
    const [reportStartDate, setReportStartDate] = useState(dayjs().startOf('month')); // Ayın ilk gününü ata
    const [reportEndDate, setReportEndDate] = useState(dayjs()); // Bugünü ata
    const [reportType, setReportType] = useState('tasima');
    const [selectedMall, setSelectedMall] = useState('Antalya Migros');
    const [loading, setLoading] = useState(false); // Yüklenme durumunu takip etmek için
    const [selectedMallIds, setSelectedMallIds] = useState([]);

    const [userMalls, setUserMalls] = useState([]); // AVM listesi için
    const [selectedMallId, setSelectedMallId] = useState(''); // Seçilen AVM'nin ID'si için

    useEffect(() => {
        try {
            const userStr = localStorage.getItem('user');
            if (userStr) {
                const user = JSON.parse(userStr);
                if (user.authLocations?.mall?.length > 0) {
                    const malls = user.authLocations.mall.map(mall => ({ id: mall.id, title: mall.title }));
                    setUserMalls(malls);
                    // Liste boş değilse ilk AVM'yi varsayılan olarak seçili yap
                    if (malls.length > 0) {
                        setSelectedMallId(malls[0].id);
                    }
                }
            }
        } catch (e) {
            console.error("Kullanıcı AVM bilgileri alınamadı:", e);
            toast.error("Yetkili AVM listesi alınamadı.");
        }
    }, []);

    // Dışa Aktarma Fonksiyonu
    const exportToExcel = async () => {
        if (!startDate || !endDate) {
            toast.warn('Lütfen başlangıç ve bitiş tarihlerini seçin.');
            return;
        }

        setLoading(true);

        try {
            switch (reportType) {
                case 'tasima':
                    await handleTasimaRaporu();

                    break;
                case 'gunsonu':
                    await handleGunSonuRaporu();
                    break;
                case 'avm':
                    await handleAvmPerformansRaporu();
                    break;
                case 'porter':
                    await handlePorterPerformansRaporu();
                    break;
                // Diğer rapor tipleri buraya eklenebilir
                default:
                    toast.error('Geçersiz rapor tipi seçildi.');
                    break;
            }
        } catch (error) {
            toast.error(error.message || 'Rapor oluşturulurken bir hata oluştu.');
        } finally {
            setLoading(false);
        }
    };

    const handlePorterPerformansRaporu = async () => {
        const token = localStorage.getItem('tokenForService');
        const startDateFormatted = startDate.format('YYYY-MM-DD');
        const endDateFormatted = endDate.format('YYYY-MM-DD');
        const pointIDs = getPointIDs();

        if (pointIDs.length === 0) {
            toast.info("Rapor oluşturulacak yetkili AVM bulunamadı.");
            return;
        }

        const response = await Services.GetPorterPerformanceReport(token, [selectedMallId], startDateFormatted, endDateFormatted);

        if (!response.data.status || typeof response.data.result !== 'object') {
            toast.info('Porter performans raporu için veri bulunamadı.');
            return;
        }

        const portersData = Object.values(response.data.result);

        if (portersData.length === 0) {
            toast.info('Porter performans raporu için veri bulunamadı.');
            return;
        }

        // 1. Başlık satırını diğer raporlardaki gibi oluşturalım.
        const titleRow = {
            'Kolon1': `Porter Performans Raporu - (${startDateFormatted} - ${endDateFormatted})`,
        };

        // 2. Sütun başlıklarını veri satırı gibi oluşturalım.
        const headerRow = {
            'Kolon1': 'AVM Adı',
            'Kolon2': 'Porter Adı',
            'Kolon3': 'İmzalatılan Koli/Kargo Sefer Sayısı',
            'Kolon4': 'İmzalatılan Araç Sefer Sayısı',
            'Kolon5': 'Toplam İmzalatılan İrsaliye Sayısı (Sefer Sayısı)',
            'Kolon6': 'İptal Edilen İş Sayısı',
            'Kolon7': 'Geciken İş Sayısı',
            'Kolon8': 'Ortalama Süre (dk)',
            'Kolon9': 'En Kısa Süre (dk)',
            'Kolon10': 'En Uzun Süre (dk)',
        };
        
        // 3. Gerçek veri satırlarını aynı yapıya dönüştürelim.
        const reportData = portersData.map(porter => {
            const toplamSefer = (porter.boxTripCount || 0) + (porter.otherTransportationToolsTripCount || 0);
            const formatSecondsToMinutes = (sec) => (sec / 60).toFixed(1);

            return {
                'Kolon1': porter.mallTitle,
                'Kolon2': `${porter.name} ${porter.lastname}`,
                'Kolon3': porter.boxTripCount || 0,
                'Kolon4': porter.otherTransportationToolsTripCount || 0,
                'Kolon5': toplamSefer,
                'Kolon6': porter.cancelledPostCount || 0,
                'Kolon7': porter.delayedHandshakesCount || 0,
                'Kolon8': formatSecondsToMinutes(porter.medianHandshakeTime || 0),
                'Kolon9': formatSecondsToMinutes(porter.shortestHandshakeTime || 0),
                'Kolon10': formatSecondsToMinutes(porter.longestHandshakeTime || 0),
            };
        });

        // 4. Tüm satırları birleştirelim: Başlık, boşluk, sütun başlıkları ve veri.
        const sendingExcelData = [titleRow, {}, headerRow, ...reportData];
        
        // 5. API'yi headers parametresi boş bir obje ile çağıralım.
        await exportApiCall(sendingExcelData, {}, 'Porter Performans Raporu');
    };

    const handleTasimaRaporu = async () => {
        if (!selectedMallId) {
            toast.warn("Lütfen bir AVM (nokta) seçin.");
            return;
        }

        const selectedMallTitle = userMalls.find(m => m.id === selectedMallId)?.title || "Rapor";
        const formattedStartDate = reportStartDate.format('DD.MM.YYYY');
        const formattedEndDate = reportEndDate.format('DD.MM.YYYY');

        const response = await axios.get(`https://system.easypointapi.com/handshakes-report-view-json.php?start=${reportStartDate.format('YYYY-MM-DD')}&end=${reportEndDate.format('YYYY-MM-DD')}&mall=${selectedMallId}`);

        if (!response.data || !Array.isArray(response.data) || response.data.length === 0) {
            toast.info('Seçilen AVM için taşıma raporu verisi bulunamadı.');
            return;
        }
        const allDataRows = response.data;

        // --- 1. EXCEL: HAM VERİ RAPORU (Porter Raporu Mantığıyla Yeniden Düzenlendi) ---
        
        // Başlık satırı
        const titleRow = {
            'Kolon1': `Taşıma Raporu (Ham Veri) - (${formattedStartDate} - ${formattedEndDate})`
        };

        // Sütun başlıkları satırı
        const headerRow = {
            'Kolon1': 'Proje',
            'Kolon2': 'Tarih',
            'Kolon3': 'İrsaliye No',
            'Kolon4': 'Talep No',
            'Kolon5': 'Saat',
            'Kolon6': 'Mağaza',
            'Kolon7': 'Sefer Sayısı',
            'Kolon8': 'Araç Tipi',
            'Kolon9': 'Taşıma Personel',
            'Kolon10': 'QR Tip',
            'Kolon11': 'Kabul Eden',
            'Kolon12': 'Toplam Paket Adedi',
            'Kolon13': 'Hareket Yönü',
            'Kolon14': 'Not'
        };
        
        // Veri satırları
        const reportData = allDataRows.map(row => ({
            'Kolon1': row[0],
            'Kolon2': row[1],
            'Kolon3': row[2],
            'Kolon4': row[3],
            'Kolon5': row[4],
            'Kolon6': row[5],
            'Kolon7': row[6],
            'Kolon8': row[7],
            'Kolon9': row[8],
            'Kolon10': row[9],
            'Kolon11': row[10],
            'Kolon12': row[11],
            'Kolon13': row[12],
            'Kolon14': row[13]
        }));
        
        // Gönderilecek final veriyi birleştirme
        const sendingRawData = [titleRow, {}, headerRow, ...reportData];
        

        // --- 2. EXCEL: ÖZET RAPORU (Bu kısım çalıştığı için aynı kalıyor) ---
        const reportDateRange = `(${formattedStartDate}-${formattedEndDate})`;
        const allTools = [...new Set(allDataRows.map(row => row[7] || '(boş)'))].sort();
        const aracBazli = allDataRows.reduce((acc, row) => { acc[row[7] || '(boş)'] = (acc[row[7] || '(boş)'] || 0) + 1; return acc; }, {});
        const personelBazli = allDataRows.reduce((acc, row) => { const personel = row[8] || '(boş)'; const aracTipi = row[7] || '(boş)'; if (!acc[personel]) acc[personel] = {}; acc[personel][aracTipi] = (acc[personel][aracTipi] || 0) + 1; return acc; }, {});
        const magazaBazli = allDataRows.reduce((acc, row) => { const magaza = row[5] || '(boş)'; const aracTipi = row[7] || '(boş)'; if (!acc[magaza]) acc[magaza] = {}; acc[magaza][aracTipi] = (acc[magaza][aracTipi] || 0) + 1; return acc; }, {});
        let pivotSheetContent = [];
        const anaBaslikKey = 'ana_baslik';
        const aracAdiKey = 'arac_adi';
        const seferSayisiKey = 'sefer_sayisi';
        const etiketKey = 'etiket';
        const genelToplamKey = 'genel_toplam';
        const mainReportTitle = `${selectedMallTitle} TAŞIMA RAPORU ${reportDateRange}`;
        pivotSheetContent.push({ [anaBaslikKey]: mainReportTitle });
        pivotSheetContent.push({});
        const aracTableTitle = `${selectedMallTitle} Araç Bazlı Taşıma Raporu ${reportDateRange}`;
        pivotSheetContent.push({ [anaBaslikKey]: aracTableTitle });
        pivotSheetContent.push({ [aracAdiKey]: 'Araç Tipi', [seferSayisiKey]: 'Toplam Sefer Sayısı' });
        Object.entries(aracBazli).forEach(([arac, sayi]) => {
            pivotSheetContent.push({ [aracAdiKey]: arac, [seferSayisiKey]: sayi });
        });
        const aracToplam = Object.values(aracBazli).reduce((sum, count) => sum + count, 0);
        pivotSheetContent.push({ [aracAdiKey]: 'Genel Toplam', [seferSayisiKey]: aracToplam });
        pivotSheetContent.push({});
        const personelTableTitle = `${selectedMallTitle} Personel Bazlı Taşıma Raporu ${reportDateRange}`;
        pivotSheetContent.push({ [anaBaslikKey]: personelTableTitle });
        const personelHeaderRow1 = {};
        if (allTools.length > 0) personelHeaderRow1[allTools[0]] = '';
        pivotSheetContent.push(personelHeaderRow1);
        const personelHeaderRow2 = { [etiketKey]: 'Personel Adı' };
        allTools.forEach(tool => personelHeaderRow2[tool] = tool);
        personelHeaderRow2[genelToplamKey] = 'Genel Toplam';
        pivotSheetContent.push(personelHeaderRow2);
        const pivotPersonelData = Object.entries(personelBazli).map(([personel, araclar]) => {
            const rowData = { [etiketKey]: personel };
            allTools.forEach(tool => { rowData[tool] = araclar[tool] || 0; });
            rowData[genelToplamKey] = allTools.reduce((sum, tool) => sum + (araclar[tool] || 0), 0);
            return rowData;
        });
        pivotSheetContent.push(...pivotPersonelData);
        const personelGenelToplamRow = { [etiketKey]: 'Genel Toplam' };
        allTools.forEach(tool => personelGenelToplamRow[tool] = pivotPersonelData.reduce((sum, p) => sum + (p[tool] || 0), 0));
        personelGenelToplamRow[genelToplamKey] = pivotPersonelData.reduce((sum, p) => sum + p[genelToplamKey], 0);
        pivotSheetContent.push(personelGenelToplamRow);
        pivotSheetContent.push({});
        const magazaTableTitle = `${selectedMallTitle} Mağaza Bazlı Taşıma Raporu ${reportDateRange}`;
        pivotSheetContent.push({ [anaBaslikKey]: magazaTableTitle });
        const magazaHeaderRow2 = { [etiketKey]: '' };
        allTools.forEach(tool => magazaHeaderRow2[tool] = tool);
        magazaHeaderRow2[genelToplamKey] = 'Genel Toplam';
        pivotSheetContent.push(magazaHeaderRow2);
        const pivotMagazaData = Object.entries(magazaBazli).map(([magaza, araclar]) => {
            const rowData = { [etiketKey]: magaza };
            allTools.forEach(tool => { rowData[tool] = araclar[tool] || 0; });
            rowData[genelToplamKey] = allTools.reduce((sum, tool) => sum + (araclar[tool] || 0), 0);
            return rowData;
        });
        pivotSheetContent.push(...pivotMagazaData);
        const magazaGenelToplamRow = { [etiketKey]: 'Genel Toplam' };
        allTools.forEach(tool => magazaGenelToplamRow[tool] = pivotMagazaData.reduce((sum, m) => sum + (m[tool] || 0), 0));
        magazaGenelToplamRow[genelToplamKey] = pivotMagazaData.reduce((sum, m) => sum + m[genelToplamKey], 0);
        pivotSheetContent.push(magazaGenelToplamRow);

        try {
            // Ham veri raporunu yeni yöntemle, boş headers objesi ile gönder
            await exportApiCall(sendingRawData, {}, 'Taşıma Raporu - Ham Veri');
            
            // Özet raporu eski, çalışan yöntemiyle gönder
            await exportApiCall(pivotSheetContent, {}, 'Taşıma Raporu - Özet');
            
            toast.success("Raporlarınız başarıyla oluşturuldu.");
        } catch (e) {
            toast.error("Raporlar oluşturulurken bir hata oluştu.");
            console.error("Rapor hatası:", e);
        }
    };

    const exportApiCall = (data, headers, sheetTitle) => {
        return api.post('excel/export', {
            type: 'excel',
            content: data,
            header: headers,
            sheetTitle: sheetTitle,
        }).then((response) => {
            if (response.data.status) {
                window.open(response.data.result, '_blank');
            } else {
                throw new Error(response.data.message || 'Excel dosyası oluşturulamadı.');
            }
        });
    };

    const handleGunSonuRaporu = async () => {
        const token = localStorage.getItem('tokenForService');
        const startDateFormatted = reportStartDate.format('YYYY-MM-DD');
        const endDateFormatted = reportEndDate.format('YYYY-MM-DD');
        const formattedStartDateForTitle = reportStartDate.format('DD.MM.YYYY');
        const formattedEndDateForTitle = reportEndDate.format('DD.MM.YYYY');

        const incompleteStatusIds = [
            '3', '4', '5', '6', '7', '8', '9', '11',
            '12', '13', '14', '18', '19', '20',
            '26', '27', '29'
        ];

        const response = await Services.GetPostsMall(token, [], incompleteStatusIds, startDateFormatted, endDateFormatted);

        if (response.data.status && response.data.result.length > 0) {
            const allJobs = response.data.result;

            const titleRow = {
                'Kolon1': `Gün Sonu Tamamlanmayan İşler Raporu - (${formattedStartDateForTitle} - ${formattedEndDateForTitle})`
            };

            const headerRow = {
                'Kolon1': 'No',
                'Kolon2': 'Oluşturulma Tar.',
                'Kolon3': 'Sip Kargo Takip No',
                'Kolon4': 'İrsaliye No',
                'Kolon5': 'Firma Kişi',
                'Kolon6': 'Çıkış Noktası',
                'Kolon7': 'Varış Noktası',
                'Kolon8': 'Adet Bilgisi',
                'Kolon9': 'Taşıma Bilgisi',
                'Kolon10': 'Kargo Firması',
                'Kolon11': 'Taşıyan Kişi',
                'Kolon12': 'İşlem Durumu'
            };

            const reportData = allJobs.map((row, index) => {
                let tasimaBilgisi = '-';
                if (row.usedVehicles && row.usedVehicles.length > 0) {
                    tasimaBilgisi = row.usedVehicles.map(v => `${v.transportationToolCount} x ${v.transportationTool}`).join(', ');
                } else if (row.requestedTransportationTool) {
                    tasimaBilgisi = `1 x ${row.requestedTransportationTool}`;
                }

                return {
                    'Kolon1': index + 1,
                    'Kolon2': moment.unix(row.createdDateTime).format('DD/MM/YYYY HH:mm'),
                    'Kolon3': row.barcode,
                    'Kolon4': row.handshakeID || '-',
                    'Kolon5': row.branchTitle || row.from.title,
                    'Kolon6': row.from.title,
                    'Kolon7': row.to.title,
                    'Kolon8': Number(row.orderInventory),
                    'Kolon9': tasimaBilgisi,
                    'Kolon10': row.shipmentFirm || 'Nakliye',
                    'Kolon11': row.porters && row.porters.length > 0 ? row.porters[0].porterNameLastname : '-',
                    'Kolon12': StatusList.find(s => s.id.toString() === row.status)?.label || `Bilinmeyen Statü (${row.status})`
                };
            });

            const sendingExcelData = [titleRow, {}, headerRow, ...reportData];
            
            
            // --- 2. EXCEL: ÖZET PİVOT RAPORU (Bu kısım çalıştığı için aynı kalıyor) ---
            const malKabuldeBekleyenler = allJobs
                .filter(job => job.status === '14')
                .reduce((acc, job) => {
                    const kargoFirmasi = job.shipmentFirm || '(boş)';
                    acc[kargoFirmasi] = (acc[kargoFirmasi] || 0) + (Number(job.orderInventory) || 0);
                    return acc;
                }, {});

            let pivotMalKabulData = Object.entries(malKabuldeBekleyenler).map(([kargoFirmasi, toplamAdet]) => ({
                'Kargo Firması': kargoFirmasi,
                'Adet Bilgisi (Toplam)': toplamAdet,
            }));

            const malKabulGenelToplam = pivotMalKabulData.reduce((sum, item) => sum + item['Adet Bilgisi (Toplam)'], 0);
            pivotMalKabulData.push({ 'Kargo Firması': 'Genel Toplam', 'Adet Bilgisi (Toplam)': malKabulGenelToplam });

            const magazateslimleri = allJobs
                .filter(job => job.status === '12')
                .reduce((acc, job) => {
                    const cikisNoktasi = job.from?.title || '(boş)';
                    acc[cikisNoktasi] = (acc[cikisNoktasi] || 0) + 1;
                    return acc;
                }, {});

            let pivotMagazaTeslimData = Object.entries(magazateslimleri).map(([cikisNoktasi, sayi]) => ({
                'Çıkış Noktası': cikisNoktasi,
                'İşlem Durumu (Tümünü Say)': sayi,
            }));

            const magazaTeslimGenelToplam = pivotMagazaTeslimData.reduce((sum, item) => sum + item['İşlem Durumu (Tümünü Say)'], 0);
            pivotMagazaTeslimData.push({ 'Çıkış Noktası': 'Genel Toplam', 'İşlem Durumu (Tümünü Say)': magazaTeslimGenelToplam });

            const pivotSheetContent = [
                { 'Kolon1': `Gün Sonu Tamamlanmayan İşler Pivot Raporu - (${formattedStartDateForTitle} - ${formattedEndDateForTitle})`, 'Kolon2': `` },
                {},
                { 'Kolon1': 'İşlem Durumu', 'Kolon2': 'Mal Kabulde Teslim Bekleyenler' },
                { 'Kolon1': 'Kargo Firması', 'Kolon2': 'Adet Bilgisi (Toplam)' },
                ...pivotMalKabulData.map(item => ({ 'Kolon1': item['Kargo Firması'], 'Kolon2': item['Adet Bilgisi (Toplam)'] })),
                {},
                { 'Kolon1': 'İşlem Durumu', 'Kolon2': 'Mağazada Teslimler' },
                { 'Kolon1': 'Çıkış Noktası', 'Kolon2': 'İşlem Durumu (Tümünü Say)' },
                ...pivotMagazaTeslimData.map(item => ({ 'Kolon1': item['Çıkış Noktası'], 'Kolon2': item['İşlem Durumu (Tümünü Say)'] }))
            ];
            
            try {
                // İlk raporu yeni yöntemle gönder
                await exportApiCall(sendingExcelData, {}, 'Gün Sonu Tamamlanmayan İşler');
                // İkinci raporu kendi yöntemiyle gönder
                await exportApiCall(pivotSheetContent, {}, 'Gün Sonu Özet Raporu');
                toast.success("Raporlarınız başarıyla oluşturuldu.");
            } catch(e) {
                toast.error("Raporlar oluşturulurken bir hata oluştu: " + e.message);
            }

        } else {
            toast.info('Seçilen kriterlere uygun tamamlanmamış iş bulunamadı.');
        }
    };

   const handleAvmPerformansRaporu = async () => {
        const token = localStorage.getItem('tokenForService');
        const startDateFormatted = reportStartDate.format('YYYY-MM-DD');
        const endDateFormatted = reportEndDate.format('YYYY-MM-DD');
        const formattedStartDateForTitle = reportStartDate.format('DD.MM.YYYY');
        const formattedEndDateForTitle = reportEndDate.format('DD.MM.YYYY');

        const mallsResponse = await Services.GetMalls(token);
        if (!mallsResponse.data.status) {
            throw new Error("AVM listesi alınamadı.");
        }
        const mallsMap = new Map(mallsResponse.data.result.map(mall => [mall.id, mall.title]));

        const pointIDs = getPointIDs();
        if (pointIDs.length === 0) {
            toast.info("Rapor oluşturulacak yetkili AVM bulunamadı.");
            return;
        }

        const allStatusIds = StatusList.map(s => s.id).filter(id => id !== 0);

        const postsResponse = await Services.GetPostsMall(token, [], allStatusIds, startDateFormatted, endDateFormatted);

        if (!postsResponse.data.status || postsResponse.data.result.length === 0) {
            toast.info('Performans raporu için veri bulunamadı.');
            return;
        }

        const allJobs = postsResponse.data.result;

        const jobsByMall = allJobs.reduce((acc, job) => {
            const mallId = job.from?.mallID;
            if (mallId) {
                if (!acc[mallId]) {
                    acc[mallId] = [];
                }
                acc[mallId].push(job);
            }
            return acc;
        }, {});

        let originalFormatData = [];
        const GECIKME_SINIRI_DAKIKA = 20;

        for (const mallId in jobsByMall) {
            if (pointIDs.includes(mallId)) {
                const mallJobs = jobsByMall[mallId];
                const mallName = mallsMap.get(mallId) || `Bilinmeyen AVM (${mallId})`;

                const totalJobs = mallJobs.length;
                const waitingJobs = mallJobs.filter(j => ['4', '5', '6', '7', '8', '19', '27'].includes(j.status)).length;
                const completedJobsList = mallJobs.filter(j => ['1', '17'].includes(j.status) && j.completedDateTime);
                const cancelledJobsList = mallJobs.filter(j => ['2', '23', '24', '25', '29'].includes(j.status));
                const completionRate = totalJobs > 0 ? (completedJobsList.length / totalJobs) * 100 : 0;
                const cancellationRate = totalJobs > 0 ? (cancelledJobsList.length / totalJobs) * 100 : 0;
                const cancelReasons = cancelledJobsList.reduce((acc, job) => {
                    const reason = job.cancelReason || 'Belirtilmemiş';
                    acc[reason] = (acc[reason] || 0) + 1;
                    return acc;
                }, {});
                const mostCommonCancelReason = Object.keys(cancelReasons).length > 0 ? Object.keys(cancelReasons).reduce((a, b) => cancelReasons[a] > cancelReasons[b] ? a : b) : 'N/A';
                let totalCompletionSeconds = 0;
                let delayedJobsCount = 0;
                completedJobsList.forEach(job => {
                    const durationSeconds = job.completedDateTime - job.createdDateTime;
                    totalCompletionSeconds += durationSeconds;
                    if (durationSeconds / 60 > GECIKME_SINIRI_DAKIKA) {
                        delayedJobsCount++;
                    }
                });
                const avgCompletionMinutes = completedJobsList.length > 0 ? Math.round((totalCompletionSeconds / completedJobsList.length) / 60) : 0;
                const delayedJobsRate = totalJobs > 0 ? (delayedJobsCount / totalJobs) * 100 : 0;
                const jobsByHour = mallJobs.reduce((acc, job) => {
                    const hour = moment.unix(job.createdDateTime).hour();
                    acc[hour] = (acc[hour] || 0) + 1;
                    return acc;
                }, {});
                let busiestHour = -1, maxJobsInHour = 0;
                for (const hour in jobsByHour) {
                    if (jobsByHour[hour] > maxJobsInHour) {
                        maxJobsInHour = jobsByHour[hour];
                        busiestHour = parseInt(hour, 10);
                    }
                }
                const busiestHourRange = busiestHour !== -1 ? `${String(busiestHour).padStart(2, '0')}:00-${String(busiestHour + 1).padStart(2, '0')}:00` : 'N/A';

                originalFormatData.push({
                    'AVM Adı': mallName,
                    'Toplam İş Emri': totalJobs,
                    'Bekleyen İş Emri': waitingJobs,
                    'Tamamlanan İş Emri': completedJobsList.length,
                    'Tamamlanma Oranı (%)': completionRate.toFixed(1),
                    'İptal Edilen İş Emri': cancelledJobsList.length,
                    'İptal Edilen İş Emri Oranı (%)': cancellationRate.toFixed(1),
                    'İptal Nedeni (En Çok Tekrarlanan)': mostCommonCancelReason,
                    'Gecikmiş İşlem': delayedJobsCount,
                    'Gecikmiş İşlem Oranı (%)': delayedJobsRate.toFixed(1),
                    'Ortalama İş Bitirme Süresi (dk)': avgCompletionMinutes,
                    'Yoğun Saatler (Saat aralığı)': busiestHourRange,
                    'Yoğunluk Dönemi (İş adedi)': maxJobsInHour > 0 ? maxJobsInHour : 'N/A',
                });
            }
        }

        const titleRow = {
            'Kolon1': `AVM İş Performans Raporu - (${formattedStartDateForTitle} - ${formattedEndDateForTitle})`
        };

        const headerRow = {
            'Kolon1': 'AVM Adı',
            'Kolon2': 'Toplam İş Emri',
            'Kolon3': 'Bekleyen İş Emri',
            'Kolon4': 'Tamamlanan İş Emri',
            'Kolon5': 'Tamamlanma Oranı (%)',
            'Kolon6': 'İptal Edilen İş Emri',
            'Kolon7': 'İptal Edilen İş Emri Oranı (%)',
            'Kolon8': 'İptal Nedeni (En Çok Tekrarlanan)',
            'Kolon9': 'Gecikmiş İşlem',
            'Kolon10': 'Gecikmiş İşlem Oranı (%)',
            'Kolon11': 'Ortalama İş Bitirme Süresi (dk)',
            'Kolon12': 'Yoğun Saatler (Saat aralığı)',
            'Kolon13': 'Yoğunluk Dönemi (İş adedi)',
        };

        const reportData = originalFormatData.map(item => ({
            'Kolon1': item['AVM Adı'],
            'Kolon2': item['Toplam İş Emri'],
            'Kolon3': item['Bekleyen İş Emri'],
            'Kolon4': item['Tamamlanan İş Emri'],
            'Kolon5': item['Tamamlanma Oranı (%)'],
            'Kolon6': item['İptal Edilen İş Emri'],
            'Kolon7': item['İptal Edilen İş Emri Oranı (%)'],
            'Kolon8': item['İptal Nedeni (En Çok Tekrarlanan)'],
            'Kolon9': item['Gecikmiş İşlem'],
            'Kolon10': item['Gecikmiş İşlem Oranı (%)'],
            'Kolon11': item['Ortalama İş Bitirme Süresi (dk)'],
            'Kolon12': item['Yoğun Saatler (Saat aralığı)'],
            'Kolon13': item['Yoğunluk Dönemi (İş adedi)'],
        }));

        const sendingExcelData = [titleRow, {}, headerRow, ...reportData];
        await exportApiCall(sendingExcelData, {}, 'AVM İş Performans Raporu');
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Card sx={{ p: { xs: 2, md: 3 }, backgroundColor: 'transparent', boxShadow: 'none' }}>
                <Stack spacing={3}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
                        <Stack direction="row" alignItems="center" spacing={1}>
                            <Typography variant="h6">Rapor Oluştur</Typography>
                            { /* <Typography variant="h6" color="text.secondary" fontWeight="400">({selectedMall})</Typography> */}
                        </Stack>
                        {/* 
                        <FormControl size="small" sx={{ minWidth: 240 }}>
                            <Select
                                value={selectedMall}
                                onChange={(e) => setSelectedMall(e.target.value)}
                                sx={{ backgroundColor: '#FFFFFF', py: 1 }}
                            >
                                {mallOptions.map(mall => (
                                    <MenuItem key={mall} value={mall}>{mall}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        */}
                    </Box>

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2, pt: 2, borderTop: `1px solid ${theme.palette.divider}` }}>
                        <Typography variant="body1" fontWeight="500">Rapor Seçimi</Typography>
                        <Stack sx={{ flexDirection: { xs: 'column', lg: 'row' }, alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                            <Stack direction="row" alignItems="center" flexWrap="wrap" gap={1}>
                                <DatePicker
                                    label="Başlangıç Tarihi"
                                    value={reportStartDate}
                                    onChange={(newValue) => {
                                        setReportStartDate(newValue);                                        
                                        console.log("Yeni Başlangıç Tarihi:", newValue);
                                    }}
                                    slots={{ openPickerIcon: CalendarIcon }}
                                    slotProps={{ textField: { size: 'small', sx: { backgroundColor: '#FFFFFF' } } }}
                                />
                                <DatePicker
                                    label="Bitiş Tarihi"
                                    value={reportEndDate}
                                    onChange={(newValue) => {
                                        setReportEndDate(newValue);                                        
                                        console.log("Yeni Bitiş Tarihi:", newValue);
                                    }}
                                    slots={{ openPickerIcon: CalendarIcon }}
                                    slotProps={{ textField: { size: 'small', sx: { backgroundColor: '#FFFFFF' } } }}
                                />
                                <Button variant="contained" onClick={() => exportToExcel(reportType)}>Rapor Oluştur ( Excel )</Button>
                                <Button variant="contained" onClick={() => exportToExcel(reportType)}>Rapor Oluştur ( PDF )</Button>
                            </Stack>
                        </Stack>
                    </Box>

                    <FormControl fullWidth size="small" sx={{ backgroundColor: '#FFFFFF' }}>
                        <InputLabel>Rapor Tipi</InputLabel>
                        <Select value={reportType} onChange={(e) => setReportType(e.target.value)} label="Rapor Tipi" sx={{ py: 1 }}>
                            <MenuItem value="tasima">Taşıma Raporu</MenuItem>
                            <MenuItem value="gunsonu">Gün Sonu Tamamlanmayan İşler Raporu</MenuItem>
                            <MenuItem value="porter">Porter Performans Raporu</MenuItem>
                            <MenuItem value="avm">Avm İş Performansı Raporu</MenuItem>
                        </Select>
                    </FormControl>
                    {(reportType === 'tasima' || reportType === 'porter') && (
                        <FormControl fullWidth size="small" sx={{ backgroundColor: '#FFFFFF' }}>
                            <InputLabel>Nokta Seçimi</InputLabel>
                            <Select
                                value={selectedMallId}
                                label="Nokta Seçimi"
                                onChange={(e) => setSelectedMallId(e.target.value)}
                                disabled={userMalls.length === 0}
                            >
                                {userMalls.map(mall => (
                                    <MenuItem key={mall.id} value={mall.id}>{mall.title}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )}
                </Stack>
            </Card>
        </LocalizationProvider>
    );
};

function mapCompletionData(list, reverse = false) {
    if (!Array.isArray(list)) return [];
    const sorted = [...list].sort((a, b) => reverse
        ? Number(a.averageCompletionTimeSeconds) - Number(b.averageCompletionTimeSeconds)
        : Number(b.averageCompletionTimeSeconds) - Number(a.averageCompletionTimeSeconds)
    );
    return sorted.map((item, idx) => ({
        name: item.mallTitle,
        value: Number(item.averageCompletionTimeSeconds) / 3600, // saat cinsinden
        color: mallColors[idx % mallColors.length],
    }));
}

function mapWorkOrderRateData(list) {
    if (!Array.isArray(list)) return [];
    return list.map((item) => {
        const porter = Number(item.waitingPostsCreatedByPorter) || 0;
        const corporational = Number(item.waitingPostsCreatedByCorporational) || 0;
        return {
            name: item.mallTitle,
            magaza: corporational,
            porter: porter,
        };
    });
}

function mapWorkOrderRatePercentData(list) {
    if (!Array.isArray(list)) return [];
    return list.map((item) => {
        const porter = Number(item.waitingPostsCreatedByPorter) || 0;
        const corporational = Number(item.waitingPostsCreatedByCorporational) || 0;
        const total = porter + corporational;
        return {
            name: item.mallTitle,
            magaza: total > 0 ? Math.round((corporational / total) * 100) : 0,
            porter: total > 0 ? Math.round((porter / total) * 100) : 0,
        };
    });
}

function mapCancelledWorkOrderRatePercentData(list) {
    if (!Array.isArray(list)) return [];
    return list.map((item) => {
        const porter = Number(item.cancelledPostsCreatedByPorter) || 0;
        const corporational = Number(item.cancelledPostsCreatedByCorporational) || 0;
        const total = porter + corporational;
        return {
            name: item.mallTitle,
            magaza: total > 0 ? Math.round((corporational / total) * 100) : 0,
            porter: total > 0 ? Math.round((porter / total) * 100) : 0,
        };
    });
}

const colorPalette = [
    "#2563EB", "#FDBA8C", "#16BDCA", "#F59E42", "#A259F7", "#38BDF8", "#6366F1", "#1D4ED8", "#0F172A"
];

function mapCancellationReasonData(cancelReasons) {
    if (!cancelReasons || typeof cancelReasons !== 'object') return { data: [], reasonKeys: [] };

    // 1. Tüm nedenleri topla (benzersiz)
    const reasonSet = new Set();
    Object.values(cancelReasons).forEach(reasonsObj => {
        Object.keys(reasonsObj).forEach(reason => reasonSet.add(reason));
    });
    const reasonKeys = Array.from(reasonSet);

    // 2. Her AVM için nedenlerin değerlerini yaz (yoksa 0)
    const data = Object.entries(cancelReasons).map(([mallTitle, reasons]) => {
        const obj = { name: mallTitle };
        reasonKeys.forEach(reason => {
            obj[reason] = reasons[reason] || 0;
        });
        return obj;
    });

    return { data, reasonKeys };
}

export default function LiveOperationTrackingRegionMaster() {
    const [mallFilter, setMallFilter] = useState('all');
    const theme = useTheme();
    const [analytics, setAnalytics] = useState(null);
    const [loading, setLoading] = useState(true);
    const [pointIDs, setPointIDs] = useState([]);
    const [longestCompletionData, setLongestCompletionData] = useState([]);
    const [shortestCompletionData, setShortestCompletionData] = useState([]);
    const [workOrderRateData, setWorkOrderRateData] = useState({
        title: 'AVM İş Emri Açma Oranı',
        subtitle: 'İş Emri Oranı',
        maxValue: 100,
        colors: [theme.palette.primary.main, theme.palette.info.main],
        series: [
            { key: 'magaza', label: 'Mağazanın Açtığı İş Emri Oranı' },
            { key: 'porter', label: 'Porterin Açtığı İş Emri Oranı' },
        ],
        data: [],
    });

    const porterDistributionData = {
        title: 'AVM Aktif / Pasif Porter Dağılımı',
        subtitle: 'Porter Sayısı',
        maxValue: 2500,
        colors: [theme.palette.primary.main, theme.palette.warning.light],
        series: [
            { key: 'aktif', label: 'Aktif Porter' },
            { key: 'pasif', label: 'Pasif Porter' },
        ],
        data: [
            { name: 'AVM 01', aktif: 1200, pasif: 800 },
            { name: 'AVM 02', aktif: 1500, pasif: 900 },
            { name: 'AVM 03', aktif: 1100, pasif: 1200 },
            { name: 'AVM 04', aktif: 700, pasif: 1300 },
            { name: 'AVM 05', aktif: 1600, pasif: 700 },
            { name: 'AVM 06', aktif: 900, pasif: 1300 },
            { name: 'AVM 07', aktif: 1250, pasif: 1100 },
        ],
    };

    const [cancellationReasonData, setCancellationReasonData] = useState({
        title: 'AVM İptal Nedenleri Oransal Dağılımı',
        subtitle: 'İptal Nedenleri Yüzdesi',
        maxValue: 100,
        colors: ['#1C64F2', '#16BDCA', '#FDBA8C'],
        series: [],
        data: [],
    });

    const [totalCancellationRateData, setTotalCancellationRateData] = useState({
        title: 'AVM Toplam İptal Oranı Dağılımı',
        subtitle: 'İptal Oranı (Yüzdesel)',
        maxValue: 100,
        colors: [theme.palette.primary.main, theme.palette.info.main],
        series: [
            { key: 'magaza', label: 'Mağazanın İptal Ettiği İş Oranı' },
            { key: 'porter', label: 'Porterin İptal Ettiği İş Oranı' },
        ],
        data: [],
    });

    const [deliveryNoteData, setDeliveryNoteData] = useState([]);
    const [topPortersData, setTopPortersData] = useState([]);

    const [workloadFilter, setWorkloadFilter] = useState('7d'); // İş Dağılımı grafiği için
    const [timeDensityFilter, setTimeDensityFilter] = useState('7d');
    const [mallWorkloadData, setMallWorkloadData] = useState([]); // AVM İş Dağılımı grafiği verisi
    const [mallTimeDensityData, setMallTimeDensityData] = useState([]); // AVM Zaman Yoğunluk grafiği verisi

    const handleWorkloadFilterChange = (newFilter) => {
        setWorkloadFilter(newFilter); // Sadece kendi filtresini güncelle
        setLoading(true); // Yükleme durumunu başlat

        const token = localStorage.getItem('tokenForService');
        const { startDate, endDate } = getDatesFromFilter(newFilter);
        const pointIDs = getPointIDs();

        // API'yi sadece ilgili veriyi almak için çağır
        Services.GetLiveAnalyticsDistricManager(token, pointIDs, startDate, endDate)
            .then(res => {
                if (res.data.status) {
                    // Sadece ve sadece İş Dağılımı grafiğinin verisini güncelle
                    setMallWorkloadData(res.data.result.mallDensity || []);
                    toast.success("İş dağılımı grafiği güncellendi.");
                } else {
                    toast.error("İş dağılımı verisi güncellenemedi.");
                }
            })
            .catch(err => toast.error("Grafik güncelleme hatası: " + err.message))
            .finally(() => setLoading(false));
    };
    
    const handleTimeDensityFilterChange = (newFilter) => {
        setTimeDensityFilter(newFilter);
        setLoading(true);

        const token = localStorage.getItem('tokenForService');
        const { startDate, endDate } = getDatesFromFilter(newFilter);
        const pointIDs = getPointIDs();
        
        Services.GetLiveAnalyticsDistricManager(token, pointIDs, startDate, endDate)
            .then(res => {
                if (res.data.status) {                    
                    setMallTimeDensityData(res.data.result.malDailyTimeDensity || []);
                    toast.success("Zaman yoğunluk grafiği güncellendi.");
                } else {
                    toast.error("Zaman yoğunluk verisi güncellenemedi.");
                }
            })
            .catch(err => toast.error("Grafik güncelleme hatası: " + err.message))
            .finally(() => setLoading(false));
    };

    const getDatesFromFilter = (filter) => {
        const endDate = moment().format('YYYY-MM-DD');
        let startDate;

        switch (filter) {
            case '1d':
                startDate = moment().format('YYYY-MM-DD');
                break;
            case '7d':
                startDate = moment().subtract(6, 'days').format('YYYY-MM-DD');
                break;
            case '15d':
                startDate = moment().subtract(14, 'days').format('YYYY-MM-DD');
                break;
            case '30d':
                startDate = moment().subtract(29, 'days').format('YYYY-MM-DD');
                break;
            case '3m':
                startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                break;
            default:
                startDate = moment().subtract(6, 'days').format('YYYY-MM-DD');
        }
        return { startDate, endDate };
    };

    useEffect(() => {        
        const fetchData = async () => {
            setLoading(true);
            try {
                const token = localStorage.getItem('tokenForService');
                if (!token) {                    
                    setAnalytics(null);
                    setLoading(false);
                    return;
                }

                const { startDate, endDate } = getDatesFromFilter("7d");

                setLoading(true);
                const res = await Services.GetLiveAnalyticsDistricManager(token, getPointIDs(), startDate, endDate);

                if (res.data.status) {
                    const result = res.data.result;
                    setAnalytics(result);
                    setMallWorkloadData(result.mallDensity || []);
                    setMallTimeDensityData(result.malDailyTimeDensity || []);
                    setLongestCompletionData(mapCompletionData(result.longestCompletedTimeMallList, false));
                    setShortestCompletionData(mapCompletionData(result.longestCompletedTimeMallList, true));

                    const mappedWorkOrder = mapWorkOrderRateData(result.mallDensityPostTracking);
                    const maxValueWorkOrder = Math.max(...mappedWorkOrder.map(item => (item.magaza + item.porter)), 1);
                    setWorkOrderRateData(prev => ({ ...prev, data: mappedWorkOrder, maxValue: maxValueWorkOrder, series: [{ key: 'magaza', label: 'Mağazanın Açtığı İş Emri' }, { key: 'porter', label: 'Porterin Açtığı İş Emri' }], colors: [theme.palette.primary.main, theme.palette.info.main] }));

                    const { data: mapped, reasonKeys } = mapCancellationReasonData(result.cancelReasons);
                    const maxValue = Math.max(...mapped.map(item => Object.values(item).filter(v => typeof v === "number").reduce((sum, v) => sum + v, 0)), 1);
                    setCancellationReasonData(prev => ({ ...prev, data: mapped, maxValue, series: reasonKeys.map(key => ({ key, label: key })), colors: reasonKeys.map((_, idx) => colorPalette[idx % colorPalette.length]) }));

                    const handshakeReport = result.handshakeReport || [];
                    const mallDensityPostTracking = result.mallDensityPostTracking || [];
                    const deliveryNoteData = handshakeReport.map((item, idx) => {
                        const mallDensity = mallDensityPostTracking.find(m => m.mallTitle === item.mallTitle);
                        return { id: idx + 1, mallName: item.mallTitle, totalNotes: Number(item.totalHandshake) || 0, totalPackages: Number(item.totalPackageCount) || 0, storeJob: mallDensity ? (Number(mallDensity.waitingPostsCreatedByPorter) || 0) + (Number(mallDensity.waitingPostsCreatedByCorporational) || 0) : 0, cancelled: mallDensity ? Number(mallDensity.cancelledPosts) || 0 : 0 };
                    });
                    setDeliveryNoteData(deliveryNoteData);

                    const maxHandshakePorterReport = result.maxHandshakePorterReport || [];
                    const topPortersData = maxHandshakePorterReport.map((item, idx) => ({ id: idx + 1, porterName: item.porterName + (item.porterLastname ? ' ' + item.porterLastname : ''), signedNotes: Number(item.totalHandshake) || 0 }));
                    setTopPortersData(topPortersData);

                    const cancelledWorkOrderRatePercentData = mapCancelledWorkOrderRatePercentData(result.mallDensityPostTracking);
                    setTotalCancellationRateData(prev => ({ ...prev, data: cancelledWorkOrderRatePercentData, maxValue: 100, series: [{ key: 'magaza', label: 'Mağazanın İptal Ettiği İş Oranı' }, { key: 'porter', label: 'Porterin İptal Ettiği İş Oranı' }] }));
                } else {                    
                    toast.error(res.data.message || 'Veriler alınamadı.');
                    setAnalytics(null);
                    setMallWorkloadData([]);
                    setMallTimeDensityData([]);
                }

            } catch (error) {
                console.error("Veri alınırken hata:", error);
                toast.error("Veriler yüklenirken bir hata oluştu.");                
                setAnalytics(null);
                setLongestCompletionData([]);
                setShortestCompletionData([]);
                setMallWorkloadData([]);
                setMallTimeDensityData([]);
                setDeliveryNoteData([]);
                setTopPortersData([]);
            } finally {
                setLoading(false);
            }
        };

        fetchData();

    }, []);



    const getPointIDs = () => {
        try {
            const userStr = localStorage.getItem('user');
            if (userStr) {
                const user = JSON.parse(userStr);                
                if (user.authLocations?.mall && Array.isArray(user.authLocations.mall)) {                    
                    const pointIDs = user.authLocations.mall
                        .map(mall => mall.points?.malkabul?.id)                        
                        .filter(id => id);

                    return pointIDs;
                }
            }
        } catch (e) {
            console.error("Kullanıcı verisi alınamadı veya formatı bozuk:", e);
        }        
        return [];
    };

    return (
        <HelmetProvider>
            <Helmet><title> Bölge Yöneticisi Paneli | Mall Logistics </title></Helmet>
            <Stack sx={{ p: { xs: 2, md: 3 }, width: '100%' }} spacing={3}>
                {loading ? (
                    <Box sx={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', bgcolor: 'rgba(255,255,255,0.7)', zIndex: 1300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <CircularProgress size={64} />
                    </Box>
                ) : (
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
                        <Typography variant="h4">İşlem Önizlemeleri</Typography>
                    </Box>
                )}

                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <MallWorkloadChart
                            data={mallWorkloadData}
                            filter={workloadFilter}
                            onFilterChange={handleWorkloadFilterChange}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <MallTimeDensityChart
                            data={mallTimeDensityData}
                            filter={timeDensityFilter}
                            onFilterChange={handleTimeDensityFilterChange}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <MallWorkloadTable data={analytics?.mallDensityPostTracking} />
                    </Grid>
                </Grid>

                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <CompletionTimeChart title="En Uzun İş Bitiren AVM'ler" data={longestCompletionData} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <CompletionTimeChart title="En Kısa İş Bitiren AVM'ler" data={shortestCompletionData} />
                    </Grid>
                </Grid>

                <Grid container spacing={3}>


                    <Grid item xs={12} md={6} position={'relative'}>
                        <Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1 }}>
                            <Typography>Geliştirme Aşamasında...</Typography>
                        </Box>
                        <Box position={'relative'} sx={{ opacity: 0.3 }}>
                            <StackedBarChart {...porterDistributionData} />
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <StackedBarChart {...workOrderRateData} />
                    </Grid>
                </Grid>


                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <StackedBarChart {...cancellationReasonData} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <StackedBarChart {...totalCancellationRateData} />
                    </Grid>
                </Grid>

                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <DeliveryNoteTrackingTable data={deliveryNoteData} />
                    </Grid>
                </Grid>

                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <TopPortersTable data={topPortersData} />
                    </Grid>
                </Grid>

                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <ReportGenerator />
                    </Grid>
                </Grid>

            </Stack>
        </HelmetProvider>
    )
}